var klevu_uc = {
    addAutocompleteLayoutToPage: function (parent) {
        var searchingAreaDiv,
            cmsContentDiv,
            cmsContentHeading,
            categoryDiv,
            productHeading,
            productDiv,
            fluidDiv,
            hoverDiv,
            hoverFluidDiv,
            suggestionsBlock,
            resultsBlock;

        // fluid div
        if (klevu_fluidLayoutEnabled) {
            fluidDiv = this.addElementToParent(parent, 'div', {
                'class': 'klevu-fluid'
            });
        } else {
            fluidDiv = parent;
        }

        // loader
        loaderContainerDiv = this.addElementToParent(fluidDiv, 'div', {
            'class': 'klevu-searching-area-l2',
            'id': 'loaderContainer',
            'style': 'display:none;'
        });
        this.addLoaderDiv(loaderContainerDiv);

        // Arrow
        this.addElementToParent(fluidDiv, 'div', {
            'class': 'klevu-arrow',
            'id': 'klevuArrow',
            'style': 'display:none;'
        });

        // searching area
        searchingAreaDiv = this.addElementToParent(fluidDiv, 'div', {
            'class': 'klevu-searching-area-l2',
            'id': 'klevuSearchingArea',
            'style': 'display:none;'
        });

        if (klevu_showPopularSearches || klevu_showRecentSerches ||
            klevu_userOptions.showRecentlyViewedItems || klevu_userOptions.showTrendingProducts) {
            hoverDiv = document.createElement('div');
            hoverDiv.setAttribute('class', 'klevu-pt-rs-hover');
            hoverDiv.setAttribute('id', 'klevu-pt-rs-hover');
            hoverDiv.style.display = "none";
            if (klevu_fluidLayoutEnabled) {
                hoverFluidDiv = document.createElement('div');
                hoverFluidDiv.setAttribute('class', 'klevu-fluid');
                hoverFluidDiv.appendChild(hoverDiv);
                parent.appendChild(hoverFluidDiv);
            } else {
                parent.appendChild(hoverDiv);
            }

            var addDiv = false;
            // add popular searches div
            if (klevu_showPopularSearches) {
                addDiv = this.addPopularSearchesDiv(hoverDiv);
            }

            // add recent searches div
            if (klevu_showRecentSerches) {
                addDiv = this.addRecentSearchesDiv(hoverDiv);
            }

            if (!addDiv) {
                hoverDiv.style.display = "none";
            }
        }

        // ============== custom area
        closeButton = this.addElementToParent(searchingAreaDiv, 'div', {
            'class': 'klevuCustomClosebtnBlock',
            'id': 'klevuCustomCloseActivate'
        });
        // escape character \'  \'
        closeButton.innerHTML = '<a href="#" class="klevuCustomClosebtn" onclick="klevu_layout.clearResults(event, \'docClick\');"><i class="icon ion-md-close"></i></a>';
        // ============== custom area ends

        // no-results div
        this.addElementToParent(searchingAreaDiv, 'div', {
            'class': 'klevuNoResults klevuNoResults-new',
            'id': 'klevuSearchNoResults',
            'style': 'display:none;'
        });

        // banner ad block - top
        if ('undefined' !== typeof klevu_showBannerAds && klevu_showBannerAds) {
            this.addElementToParent(searchingAreaDiv, 'div', {
                'class': 'klevu-banner-ad',
                'id': 'klevuBannerAdTop',
                'style': 'padding:0px;'
            });
        }

        // suggestions block
        suggestionsBlock = this.addElementToParent(searchingAreaDiv, 'div', {
            'class': 'klevuSuggestionsBlock',
            'id': 'klevuSuggestionsBlock'
        });

        // Autosuggestion
        this.addElementToParent(suggestionsBlock, 'div', {
            'class': 'klevuAutoSuggestion-l2',
            'id': 'klevuAutoCompleteArea',
            'style': 'display:none;'
        });

        // CMS
        cmsContentDiv = this.addElementToParent(suggestionsBlock, 'div', {
            'class': 'klevuAutoSuggestion-l2',
            'id': 'klevuCmsContentArea',
            'style': 'display:none;'
        });

        cmsContentHeading = this.addElementToParent(suggestionsBlock, 'div', {
            'class': 'klevuSuggestionHeading',
            'style': 'display:none;'
        });
        cmsContentHeading.innerHTML = '<span class="klevuHeadingText">Pages</span>';

        // category
        categoryDiv = this.addElementToParent(suggestionsBlock, 'div', {
            'class': 'klevuAutoSuggestion-l2',
            'id': 'klevuCategoryArea',
            'style': 'display:none;'
        });


        //results block
        resultsBlock = this.addElementToParent(searchingAreaDiv, 'div', {
            'class': 'klevuResultsBlock',
            'id': 'klevuResultsBlock'
        });

        // Products
        productHeading = this.addElementToParent(resultsBlock, 'div', {
            'class': 'klevuSuggestionHeading',
            'id': 'klevuProductHeading',
            'style': 'display:none;'
        });

        productDiv = this.addElementToParent(resultsBlock, 'div', {
            'class': 'klevuSearchResults-l2',
            'id': 'productsList',
            'style': 'display:none;'
        });


        //static block
        staticDiv = this.addElementToParent(searchingAreaDiv, 'div', {
            'class': 'klevuAutoSuggestion-l2',
            'id': 'klevuStaticArea',
            'style': 'display:block;'
        });

        staticDivHead = this.addElementToParent(staticDiv, 'div', {
            'class': 'klevuSuggestionHeading'
        });
        staticDivHead.innerHTML = '<span class="klevuHeadingText">Need More Help?</span>';
        staticDivList = this.addElementToParent(staticDiv, 'ul', {
            'class': 'klevuULStaticAreaList'
        });
        staticDivList.innerHTML += '<li><a href="tel:01423359730">Call us on 01423359730</a></li>';

        // banner ad block - bottom
        if ('undefined' !== typeof klevu_showBannerAds && klevu_showBannerAds) {
            this.addElementToParent(searchingAreaDiv, 'div', {
                'class': 'klevu-banner-ad',
                'id': 'klevuBannerAdBottom',
                'style': 'padding:0px;'
            });
        }
    },
    showLandingPageData: function (product) {
        var toReturn = '',
            toAppendwithSalePrice = '',
            priceWithCurrency = '',
            appendCurrencyAtLast = false,
            salepriceClass = 'kuSalePrice',
            priceFormatter, priceToSet,
            showToLabel = false,
            additionalParams = '',
            keywords = document.getElementById('searchedKeyword').value,
            trackingParams = "",
            originalPrice, salePrice;

        product = klevu_productCustomizations(product);
        if (product.productImage.trim().length === 0) {
            product.productImage = klevu_userOptions.noImageUrl;
        }

        if (klevu_userOptions.openProductClicksInNewWindow) {
            additionalParams = ' target="_blank"';
        } else {
            additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
        }
        trackingParams = '{' +
            'data: {' +
            'code: \'' + escape(product.productCode) + '\',' +
            'url: \'' + escape(product.productUrl) + '\',' +
            'name: \'' + escape(product.productName) + '\',' +
            'salePrice: \'' + escape(product.salePrice) + '\',' +
            'rating: \'' + escape(product.rating) + '\',' +
            'position: ' + product.productPosition + ',' +
            'category: \'' + escape(product.category) + '\'' +
            '},' +
            'apiKey: null,' +
            'keywordsLP: \'' + escape(keywords) + '\'' +
            '}';
        // code for the result block
        toReturn += '<li>';
        originalPrice = product.productPrice ? +(product.productPrice) : 0;
        salePrice = product.salePrice ? +(product.salePrice) : 0;
        if (originalPrice > salePrice) {
            product.discount = (((originalPrice - salePrice) / originalPrice) * 100).toString();
        } else {
            product.discount = "0";
        }

        toReturn += '<div><a href="' + product.productUrl.replace(/"/g, "%22") +
            '" target="_blank" ';
        if (klevu_commons.isMobileDevice()) {
            toReturn += ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
        } else {
            toReturn += ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
        }

        toReturn += '<img src="' +
            product.productImage + '" onerror="this.onerror=null;this.src=\'' +
            klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/></a></div>';

        toReturn += '<div class="kuNameDesc">';
        toReturn += '<div class="kuName is-bold"><a class="is-list-item-title title is-size-6" href="' + product.productUrl.replace(/"/g, "%22") +
            '" target="_blank" ';
        if (klevu_commons.isMobileDevice()) {
            toReturn += ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
        } else {
            toReturn += ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
        }
        toReturn += product.productName + '</a></div>';
        toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';
        if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
            Number(product.rating) <= 5 && Number(product.rating) >= 0) {
            var starWidth = 20 * Number(product.rating);
            toReturn += '<div class="kuStarsSmall">' +
                '<div class="kuRating" style="width:' + starWidth +
                '%;"></div></div>';
        }
        toReturn += '</div>';

        toReturn += '<div class="kuPrice">';
        if (klevu_showPrices) {
            if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
                toReturn += klevu_commons.showOriginalAndSalePrices('LANDING', product,
                    salepriceClass, 'kuSalePrice kuSpecialPrice');
            } else {
                toReturn += klevu_commons.showProductPrices('LANDING', product,
                    salepriceClass, 'kuSalePrice kuSpecialPrice');
            }
        }

        if (klevu_userOptions.vatCaption.trim().length > 0) {
            toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
        }

        toReturn += '</div>';
        if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
            toReturn += '<div class="kuAddtocart">' +
                '<a href="' + product.productUrl.replace(/"/g, "%22") +
                '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
                '</div>';
            toReturn += '<div class="klevu-clearboth-listview"></div>';
        }
        toReturn += '<div class="kuClearLeft"></div>';
        toReturn += '</li>';

        return toReturn;
    }
}


function klevu_uc_productCustomizations(product) {
    // if (typeof klevu_loginCustomerGroup === undefined || klevu_loginCustomerGroup === "") {
      product.startPrice = Number(product.startPrice) > 0 ? Number(product.startPrice) * 1.2 + '' : '';
      product.productPrice = Number(product.productPrice) > 0 ? Number(product.productPrice) * 1.2 + '' : '';
      product.price = Number(product.price) > 0 ? Number(product.price) * 1.2 + '' : '';
      product.oldPrice = Number(product.oldPrice) > 0 ? Number(product.oldPrice) * 1.2 + '' : '';
      product.salePrice = Number(product.salePrice) > 0 ? Number(product.salePrice) * 1.2 + '' : '';
      // product.priceToDisplay = '099 test'
  
      // console.log(product.priceToDisplay);
    // }
  
    // console.log('-======-');
   
    return product;
  }